// src/utils/currentUserId.js
const toInt = (v) => {
  const n = parseInt(String(v ?? "").trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export function resolveCurrentUserId() {
  if (typeof window === "undefined") return null;

  const s = window.sessionStorage;
  const l = window.localStorage;
  const read = (k) => (s?.getItem(k) ?? l?.getItem(k));

  // 1) chaves diretas (prioriza IdFuncionario)
  const keys = [
    "IdFuncionario",
    "idFuncionario",
    "DevId",
    "DEV_ID",
    "CodCadFunc",
    "codFunc",
  ];

  for (const k of keys) {
    const v = read(k);
    const n = toInt(v);
    if (n) return n;
  }

  // 2) objeto "user" salvo em JSON
  try {
    const raw = read("user");
    if (raw) {
      const u = JSON.parse(raw);
      const cand =
        u.IdFuncionario ??
        u.idFuncionario ??
        u.id ??
        u.ID ??
        u.CodCadFunc ??
        u.codFunc;
      const n = toInt(cand);
      if (n) return n;
    }
  } catch {
    // ignora
  }

  // 3) cache legado da tela de mensagens (se existir)
  const fromCache = read("SSW_MSG_USER");
  const nCache = toInt(fromCache);
  if (nCache) return nCache;

  // 4) nada encontrado
  return null;
}
